/* Bague Elora — apercu vivant + image personnalisee dans le panier.
   Un seul fichier pour Savarela (EN) et Dravella (ES) : tout ce qui differe est passe
   par window.ELORA_CFG depuis le template.

   1) Page produit : tant qu'une pierre n'est pas choisie, SON cote change toutes les 1,5 s.
      Choisir une pierre fige ce cote ; l'autre continue. Les deux choisis, plus rien ne bouge.
   2) Panier : la ligne porte l'image de LA bague configuree, pas le packshot d'origine.
*/
(() => {
  const CFG = window.ELORA_CFG;
  if (!CFG || !CFG.base) return;
  const MOIS = ["january","february","march","april","may","june",
                "july","august","september","october","november","december"];
  const TICK = 1500;
  const PREFIXE = CFG.prefixe || "svl-elora";     /* svl-elora | dvl-elora */
  const HERO    = CFG.hero    || "svl-elora-01-hero";
  const ARGENT  = (CFG.argent || "silver").toLowerCase();  /* Silver | Plata */

  /* 🔴 Shopify met UN AN de cache sur les assets. Une URL construite a la main sans version
     resservirait eternellement la premiere image uploadee sous ce nom. */
  const V = CFG.v ? ("?v=" + CFG.v) : "";
  const url = (metal, l, r) => `${CFG.base}${PREFIXE}-${metal}-${MOIS[l]}-${MOIS[r]}.webp${V}`;

  /* ------------------------------------------------------------------ PANIER */
  const METAL_PAR_VARIANTE = (() => {
    const m = {};
    document.querySelectorAll("[data-svb] script[type='application/json'][data-config]")
      .forEach(s => {
        try {
          (JSON.parse(s.textContent).variants || []).forEach(v => {
            m[v.id] = String(v.option1 || "").toLowerCase() === ARGENT ? "silver" : "gold";
          });
        } catch (e) {}
      });
    return m;
  })();

  /* 🔴 On lit _stone_ref ("03 / 10"), que le configurateur pose deja : c'est le seul champ
     INDEPENDANT DE LA LANGUE. Les noms de mois sont "March" sur Savarela et "Marzo" sur
     Dravella — s'en servir obligerait a maintenir deux tables. */
  const imagePour = (item) => {
    const ref = (item.properties || {})._stone_ref;
    if (!ref) return null;
    const p = String(ref).split("/").map(x => parseInt(x.trim(), 10) - 1);
    if (p.length !== 2 || p.some(n => isNaN(n) || n < 0 || n > 11)) return null;
    return url(METAL_PAR_VARIANTE[item.id] || "gold", p[0], p[1]);
  };

  /* 🔴 On INTERCEPTE l'ajout au panier : ecouter cartUpdate arriverait apres le rendu,
     la ligne serait deja peinte avec le packshot d'origine. */
  const fetchOriginal = window.fetch;
  window.fetch = function (entree, options) {
    try {
      const u = typeof entree === "string" ? entree : (entree && entree.url) || "";
      if (/\/cart\/add/.test(u) && options && typeof options.body === "string") {
        const corps = JSON.parse(options.body);
        if (Array.isArray(corps.items)) {
          corps.items.forEach(it => {
            const src = imagePour(it);
            if (src) { it.properties = it.properties || {}; it.properties._img = src; }
          });
          options = Object.assign({}, options, { body: JSON.stringify(corps) });
        }
      }
    } catch (e) {}
    return fetchOriginal.apply(this, [entree, options]);
  };

  let enCours = false;
  async function peindrePanier() {
    if (enCours) return;
    enCours = true;
    try {
      const cart = await fetchOriginal("/cart.js").then(r => r.json());
      const lignes = document.querySelectorAll(
        "cart-drawer .cart-item, cart-drawer tr.cart-item, #main-cart-items .cart-item");
      cart.items.forEach((it, i) => {
        const src = (it.properties && it.properties._img) || imagePour(it);
        const ligne = lignes[i];
        if (!src || !ligne) return;
        /* 🔴 on ne repeint que la VIGNETTE : les pastilles de pierres (.elora-bs) sont
           aussi des <img> dans cette ligne et se retrouveraient remplacees par la bague. */
        ligne.querySelectorAll("img:not(.elora-bs img)").forEach(im => {
          if (im.closest(".elora-bs")) return;
          if (im.dataset.eloraCart === src) return;
          im.dataset.eloraCart = src;
          im.removeAttribute("srcset"); im.removeAttribute("sizes");
          im.src = src;
        });
      });
    } catch (e) {} finally { enCours = false; }
  }
  const plusTard = () => setTimeout(peindrePanier, 120);
  document.addEventListener("DOMContentLoaded", plusTard);
  if (document.readyState !== "loading") plusTard();
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, plusTard);
  }
  (function surveille() {
    const d = document.querySelector("cart-drawer") || document.querySelector("#main-cart-items");
    if (!d) return setTimeout(surveille, 500);
    new MutationObserver(plusTard).observe(d, { childList: true, subtree: true });
    plusTard();
  })();

  /* ----------------------------------------------------------- PAGE PRODUIT */
  /* 🔴 Ce fichier est appele depuis le tiroir du panier, qui peut etre rendu AVANT le
     contenu de la page : sans cette attente, [data-svb] n'existe pas encore et la
     rotation ne demarrerait jamais. */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProduit);
  } else { initProduit(); }
  function initProduit() {
  const svb = document.querySelector("[data-svb]");
  if (!svb) return;

  /* 🔴 La vignette du PANIER affiche le meme packshot : sans cette exclusion elle serait
     prise dans la rotation, et une bague deja commandee se remettrait a changer de couleurs
     a chaque rechargement. Le panier est peint par peindrePanier(), pas ici. */
  const dansLePanier = (el) => !!el.closest(
    "cart-drawer, cart-drawer-items, #main-cart-items, #main-cart-footer, .cart-item, .cart__items, .drawer");
  const estHero = (i) =>
    i.getAttribute("src") && i.getAttribute("src").includes(HERO) ||
    i.getAttribute("srcset") && i.getAttribute("srcset").includes(HERO);
  const cibles = [...document.querySelectorAll("img")].filter(i => estHero(i) && !dansLePanier(i));
  if (!cibles.length) return;

  const montre = (u) => cibles.forEach(i => {
    i.removeAttribute("srcset"); i.removeAttribute("sizes"); i.src = u;
  });

  const metal = () => {
    const on = svb.querySelector('.svb__swatch[aria-pressed="true"]');
    return ((on && on.dataset.color) || "").toLowerCase() === ARGENT ? "silver" : "gold";
  };

  /* 🔴 Le theme PRESELECTIONNE le 1er mois des deux cotes : lire la valeur ne dit pas si la
     visiteuse a choisi. On suit l'INTERACTION, cote par cote. */
  const touche = { "left-1": false, "right-1": false };
  const choisi = (n) => {
    if (!touche[n]) return null;
    const s = svb.querySelector(`select[name="${n}"]`);
    const v = s && s.value;
    return (v === "" || v == null) ? null : parseInt(v, 10);
  };

  const alea = () => Math.floor(Math.random() * 12);
  let volG = alea(), volD = alea();

  const peindre = () => {
    const g = choisi("left-1"), d = choisi("right-1");
    montre(url(metal(), g === null ? volG : g, d === null ? volD : d));
    return { g, d };
  };

  let timer = null;
  const tic = () => {
    const { g, d } = peindre();
    if (g !== null && d !== null) { clearInterval(timer); timer = null; return; }
    if (g === null) volG = alea();          /* seul le cote NON choisi change */
    if (d === null) volD = alea();
  };

  const surChangement = () => {
    peindre();
    if (choisi("left-1") !== null && choisi("right-1") !== null && timer) {
      clearInterval(timer); timer = null;
    }
  };
  const marquer = (e) => {
    const s = e.target.closest("select");
    if (s && Object.prototype.hasOwnProperty.call(touche, s.name)) touche[s.name] = true;
    surChangement();
  };
  svb.addEventListener("input", marquer);
  svb.addEventListener("change", marquer);
  svb.addEventListener("click", (e) => {
    if (e.target.closest(".svb__swatch")) setTimeout(surChangement, 30);
  });

  const depart = [];
  for (let k = 0; k < 6; k++) depart.push(url(metal(), alea(), alea()));
  let prets = 0, lance = false;
  const demarrer = () => {
    if (lance) return; lance = true;
    peindre();
    timer = setInterval(tic, TICK);
  };
  depart.forEach(u => {
    const im = new Image();
    im.onload = im.onerror = () => { if (++prets === depart.length) demarrer(); };
    im.src = u;
  });
  setTimeout(demarrer, 1200);
  }
})();
